import React, { useState, useEffect } from 'react';
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';
import * as yup from "yup";
import cn from 'classnames';
import { yupResolver } from '@hookform/resolvers/yup';

import { InputControlled, Button } from 'components';
import { changePassword } from 'services/auth'
import { toast } from 'react-toastify';

interface IFormInputs {
    email: string
    verificationCode: string
    password: string
}

export const ResetPasswordForm = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    
    useEffect(() => {
        setTimeout(() => {
            setFadeIn(true);
        }, 500);
    }, [])

    const schema = yup.object({
        email: yup.string().email(t('error.invalidEmail')).required(t('error.requiredEmail')),
        verificationCode: yup.string().required(t('error.requiredField')),
        password: yup.string().required(t('error.requiredField'))
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\[\]{}\(\)?\-\"!@#%&\/,><\':;|_~`])\S{8,99}$/, t('error.invalidPassword'))
            .required(t('error.requiredField'))
    }).required();

    const { handleSubmit, control, reset, formState: { errors } } = useForm<IFormInputs>({
        resolver: yupResolver(schema)
    });

    const handleOnSubmit: SubmitHandler<IFormInputs> = async data => {
        try {
            setLoading(true);
            console.log({data})
            await changePassword(data.email, data.verificationCode, data.password);
            // reset();
            toast.success(t('passwordChanged'));
            navigate('/auth/login', {replace: true});
        } catch (error: any) {
            console.log({error})
            toast.error(t('error.changePassword'));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <h2 className={cn("mb-8 text-3xl c-orange font-light enter-y delay-100", {fadeIn})}>{t('resetPassword')}</h2>
            <form onSubmit={handleSubmit(handleOnSubmit)}>
                    <InputControlled
                        name="email"
                        control={control}
                        defaultValue={''}
                        className={cn("block mb-5 enter-y delay-200", {fadeIn})}
                        labelClass="sm"
                        label={t('email')}
                        placeholder={t('enterYourEmailAddress')}
                    />
                    <InputControlled
                        name="verificationCode"
                        control={control}
                        defaultValue={''}
                        className={cn("block mb-5 enter-y delay-200", {fadeIn})}
                        labelClass="sm"
                        label={t('verificationCode')}
                    />
                    <InputControlled
                        name="password"
                        type="password"
                        control={control}
                        defaultValue={''}
                        className={cn("block mb-5 enter-y delay-200", {fadeIn})}
                        labelClass="sm"
                        label={t('password')}
                        placeholder={t('password')}
                    />
                <div className={cn("flex justify-between mt-8 enter-y delay-300", {fadeIn})}>
                    <Button type="submit" loading={loading} className="c-orange font-extrabold text-sm">+ {t('send')}</Button>
                    <Button type="link" underline to="/auth/login" className="c-orange text-sm">{t('login')}</Button>
                </div>
            </form>
        </div>
    )

}